import { cva, VariantProps } from "class-variance-authority";

const avatarVariants = cva(
  "flex items-center justify-center overflow-hidden rounded-full border border-gray-100 dark:border-gray-900",
  {
    variants: {
      size: {
        default: "size-5 text-xs",
        big: "size-6 text-base",
      },
    },
    defaultVariants: {
      size: "default",
    },
  },
);

type AvatarVariantProps = VariantProps<typeof avatarVariants>;

interface StaffAvatarProps extends AvatarVariantProps {
  userStaff: {
    firstName: string;
    lastName: string;
    picture?: string;
  };
}

export const StaffAvatar = ({
  userStaff,
  size = "default",
}: StaffAvatarProps) => {
  const initials = `${userStaff.firstName[0]}${userStaff.lastName[0]}`;
  const name = `${userStaff.firstName} ${userStaff.lastName}`;

  return (
    <div className="flex flex-row items-center gap-2">
      <div className={avatarVariants({ size })}>
        {userStaff.picture ? (
          <img
            src={userStaff.picture}
            alt="avatar"
            className="size-full object-cover"
          />
        ) : (
          <div className="flex size-full items-center justify-center font-semibold text-gray-500">
            {initials}
          </div>
        )}
      </div>
      <div className="flex flex-col justify-center">
        <div className="dark:text-gray-0 line-clamp-1 text-sm font-semibold text-gray-950">
          {name}
        </div>
      </div>
    </div>
  );
};
